/*
 * @Author: tangf tangf_86@163.com
 * @Date: 2024-03-26 13:52:11
 * @LastEditors: tangf tangf_86@163.com
 * @LastEditTime: 2024-04-23 19:56:57
 * @FilePath: \hippo-web-admin\src\api\doctor\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';

/**
 * 获取Follower列表
 */
export const list = ({ status, memberEmail = '', pageNumber = 1, PageSize = 10 } = {}) => {
  return request({
    url: '/web/follower/loadMyFollowers',
    method: 'post',
    data: {  memberEmail, pageNumber, PageSize }
  })
}

/**
 * 获取申请关注我的列表
 */
export const list2 = ({ status, memberEmail = '', pageNumber = 1, PageSize = 10 } = {}) => {
  return request({
    url: '/web/follower/loadMyFollowerRequests',
    method: 'post',
    data: {  memberEmail, pageNumber, PageSize }
  })
}


/**
 * 增加Follower
 */
export const add = ({ email, message } = {}) => {
  return request({
    url: '/web/follower/addFollowerRequest',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { email, message }
  })
}

/**
 * 删除我关注的成员
 */
export const share = ({ followerId } = {}) => {
  return request({
    url: '/web/follower/delMyFollower',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { followerId }
  })
}

/**
 * 同意/拒绝申请
 */
export const changeStatus = ({ id, status } = {}) => {
  return request({
    url: '/web/follower',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { id, status }
  })
}

/**
 * 根据id获取用户信息
 */
export const getFollowerUserInfo = ({ memberId } = {}) => {
  return request({
    url: '/web/follower/loadMemberInfoById',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: { memberId }
  })
}